import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@foxera/environments/enviroment';
import { IEmployeeShiftPayload } from '@foxera/shared/interfaces/schedule-shift.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly URL = `${environment.api_business_base_url}/authentication`;
  constructor(private http: HttpClient) {}

  logout(userId: string): Observable<IEmployeeShiftPayload> {
    const url = `${this.URL}/logout/${userId}`;
    return this.http.post<IEmployeeShiftPayload>(
      url,
      {},
      {
        withCredentials: true,
      }
    );
  }
}
